import { HttpClient } from '@angular/common/http';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { ProgramListItemActionButtonConfiguration } from '@shared/components/program-list-item/program-list-item.component';
import { ProgramTemplate, ProgramTemplateData } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ProgramTemplatePreviewDialogComponent } from './program-template-preview/program-template-preview-dialog.component';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Router } from '@angular/router';

@Component({
  selector: 'program-template-picker-dialog',
  templateUrl: './program-template-picker-dialog.component.html',
  styleUrls: ['./program-template-picker-dialog.component.scss']
})
export class ProgramTemplatePickerDialogComponent implements OnInit {
  templates: ProgramTemplate[];
  
  constructor(
    private _courseApiService: CoursesAPIService,
    private _currentHubService: CurrentHubService,
    private _http: HttpClient,
    private _dialog: MatDialog,
    protected _router: Router
  ) {}

  async ngOnInit() {
    const templateData = await this._http.get<ProgramTemplateData>(environment.programsTemplateFile).toPromise();
    this.templates = templateData.templates.filter(t => !t.hidden);
  }

  getActionButtons(template: ProgramTemplate, forceUseAction = false): ProgramListItemActionButtonConfiguration[] {
    return template.explore && !forceUseAction
      ? [{ label: "Explore this template", action: () => this.exploreTemplate(template) }]
      : [{ label: "Use this template", action: async () => await this.useTemplate(template) }]
  }

  exploreTemplate(template: ProgramTemplate) {
    this._dialog.open(ProgramTemplatePreviewDialogComponent, {
      backdropClass: 'click-through-dialog-backdrop',
      panelClass: ['fullscreen-dialog', 'programs-image-background'],
      data: { template, actionButtons: this.getActionButtons(template, true) }
    });
  }

  async useTemplate(template: ProgramTemplate) {
    try {
      const newProgram = await this._courseApiService.duplicateLearnspace(template.program_id, this._currentHubService.hub.id).toPromise();
      this._router.navigate([`${this._currentHubService.getHubURLTitle()}/${newProgram.id}`]);
      this._dialog.closeAll();
    } catch (error) {
      console.log(error);
    }
  }
}
